document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    // Look for an <a> anywhere inside the mobile menu
    const link = event.target.closest('.menu-drawer__menu-item');
    if (!link) return;

    // Only handle links with a hash in the href
    const href = link.getAttribute('href');
    if (!href || !href.includes('#')) return;

    // Find the summary that toggles the drawer
    const summary = document.querySelector(
      '#Details-menu-drawer-container > summary.header__icon--summary'
    );
    if (summary && summary.getAttribute('aria-expanded') === 'true') {
      summary.click(); // close the drawer
    }

    // Smooth scroll to the anchor on the same page
    const targetId = href.split('#')[1];
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }, 200);
    }
  });
});